// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"bfe_a"};